import { performerRetrieve } from "parog-web/utils/dmp-utils";
import type {
  Execution,
  Performer,
  Procedure,
  Section
} from "./abstract-dmp-parser";
import AbstractDmpParser from "./abstract-dmp-parser";

interface Measurement {
  measurementSourceConcept: string;
  measurementSourceValue: string;
  measurementSourceLabel: string;
}

export interface BiologicalActExecution extends Execution {
  measurements: Array<Measurement>;
}

export default class BiologicalActDmpParser extends AbstractDmpParser {
  journalEventClassName = "BiologicalActRefundedJournalEvent";

  canParse(section: Section): boolean {
    const code = section?.code?._attributes?.code;
    const title = section?.title?._text;
    return code == "29554-3" && title == "Biologie";
  }

  parse(section: Section): Array<BiologicalActExecution> {
    return this.getEntries(section)
      .map(entry => {
        const procedure = entry.procedure;

        const source = procedure?.code
          ?._attributes as Procedure["code"]["_attributes"];

        if (source.nullFlavor || source.codeSystem == "1.2.250.1.213.2.63")
          return;

        const occurredAt = this.parseOccurredAt(procedure);
        if (!occurredAt) return;

        const measurementSourceConcept = "NABM";

        const measurementSourceValue = source.code;
        const measurementSourceLabel = source.displayName;

        if (
          measurementSourceConcept &&
          measurementSourceValue &&
          measurementSourceLabel
        ) {
          return {
            occurredAt,
            measurements: [
              {
                measurementSourceConcept,
                measurementSourceValue,
                measurementSourceLabel
              }
            ],
            performers: (entry.procedure?.performer as Array<Performer>).map(
              performer => performerRetrieve(performer)
            )
          };
        }

        return null;
      })
      .filter(Boolean) as BiologicalActExecution[];
  }
}
